import React from 'react';
import styles from './MetricSelectionDialog.module.scss';
import { DialogContent } from '@mui/material';
import BaseDialog from '../DialogWrappers/BaseDialog';
import { isConcentricCardSelected } from '../../utils';

import type { SetMetrics, ConcentricCard } from '../../types';

export interface MetricSelectionDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (card: ConcentricCard) => void;
  cards: ConcentricCard[];
  currentMetrics?: SetMetrics;
}

const MetricSelectionDialog: React.FC<MetricSelectionDialogProps> = ({
  isOpen,
  onClose,
  onSelect,
  cards,
  currentMetrics,
}) => {
  const renderOptionsGrid = () => {
    const rows = Array.from({ length: Math.ceil(cards.length / 2) }, (_, i) => [
      i * 2,
      i * 2 + 1,
    ]);
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          width: '100%',
        }}
      >
        {rows.map((row, rowIdx) => (
          <div key={rowIdx} style={{ display: 'flex', gap: 16, width: '100%' }}>
            {row.map((idx) => {
              const card = cards[idx];
              if (!card) return <div key={idx} style={{ flex: 1 }} />;
              const isSelected =
                !!currentMetrics &&
                isConcentricCardSelected(card, currentMetrics);
              return (
                <div
                  key={idx}
                  style={{
                    flex: 1,
                    border: `${isSelected ? 2 : 1}px solid ${isSelected ? 'var(--color-accent)' : 'var(--color-text-1)'}`,
                    borderRadius: 10,
                    padding: 16,
                    color: isSelected
                      ? 'var(--color-accent)'
                      : 'var(--color-text-1)',
                    cursor: 'pointer',
                    minWidth: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  onClick={() => {
                    onSelect(card);
                  }}
                >
                  <div style={{ fontWeight: 700, fontSize: 18 }}>
                    {card.title}
                  </div>
                  <div style={{ fontSize: 16, margin: '8px 0' }}>
                    {card.range}
                  </div>
                  <div style={{ fontSize: 13, opacity: 0.8 }}>
                    {card.subtitle}
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    );
  };

  return (
    <BaseDialog
      onClose={onClose}
      isOpen={isOpen}
      title="Choose a Concentric Value"
      actions={[]}
      style={{
        width: '1000px',
        margin: '0 auto',
      }}
    >
      <DialogContent
        className={styles.metricDialog}
        style={{ flexDirection: 'column', alignItems: 'flex-start' }}
      >
        <span className={styles.subtitle}>
          Tap on one to select as your goal
        </span>
        {renderOptionsGrid()}
      </DialogContent>
    </BaseDialog>
  );
};

export default MetricSelectionDialog;
